// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:  "https://backend-olxs.onrender.com/",
});

export default axiosInstance;

// export const weburl = "https://backend-olxs.onrender.com/";
export const weburl = "https://backend-olxs.onrender.com/";
export const testurl = "https://backend-olxs.onrender.com/";

export const shopurl = "https://admin.thehelply.com/";
export const mainurl = "https://thehelply.com/";
export const fronturl = "https://thehelply.com/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;